<template>
  <div :class="{ 'sticky-header': true, 'has-bottom-slot': hasBottomSlot(), 'is-sticky': isSticky, 'is-auto-width': autoTitleWidth }">
    <div class="wrapper">
      <h1>
        {{ title }}
        <small v-if="subtitle">
          {{ subtitle }}
        </small>
      </h1>

      <slot name="ui" />

      <div
        v-if="hasBottomSlot()"
        class="bottom">
        <slot name="bottom-ui" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'sticky-header',
  props: {
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    isSticky: {
      type: Boolean,
      default: true
    },
    autoTitleWidth: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    hasBottomSlot () {
      return !!this.$slots['bottom-ui'];
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

.sticky-header {
  background: $color-light;
  border-bottom: 1px solid $color-border-light;
  margin: 0;
  position: static;

  &.is-sticky {
    left: 5.4rem;
    position: absolute;
    position: sticky;
    top: 7rem;
    z-index: 99;
  }

  &.is-auto-width {
    .wrapper {
      h1 {
        width: auto;
      }
    }
  }

  .wrapper {
    align-items: center;
    display: flex;
    height: 8rem;
    margin: 0 auto;
    max-width: 1400px;
    padding: 0;
    position: relative;

    h1 {
      font-size: 2.4rem;
      font-weight: 400;
      line-height: 8rem;
      margin: 0;
      padding: 0;
      position: relative;
      width: 100%;

      & > small {
        border-left: 1px solid $color-text-lightest;
        color: $color-text-light;
        font-size: 1.4rem;
        line-height: 2;
        margin-left: 1rem;
        padding-left: 1rem;
      }
    }

    select {
      height: 3.6rem;
      max-width: 32rem;

      & + .button {
        margin-left: 2rem;
      }
    }
  }

  &.has-bottom-slot {
    .bottom {
      align-items: center;
      display: flex;
      padding: 0;
      width: 100%;
    }

    .wrapper {
      flex-wrap: wrap;
      height: 15rem;

      h1 {
        &:after {
          background: $color-border-light;
          bottom: 0;
          content: "";
          height: 1px;
          left: 0;
          position: absolute;
          right: 0;
        }
      }
    }
  }
}

@media (max-width: 1680px) {
  .sticky-header {
    .wrapper {
      margin: 0 auto;
      max-width: 1400px;
    }
  }
}

@media (max-width: 1480px) {
  .sticky-header {
    .wrapper {
      margin: 0 2rem;
      max-width: calc(100% - 4rem);
    }
  }
}

@media (max-width: 640px) {
  .sticky-header {
    &.is-sticky {
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;
    }

    .wrapper {
      height: 5rem;
      margin: 0 1rem;
      max-width: calc(100% - 2rem);

      h1 {
        line-height: 1;

        small {
          border: none;
          display: block;
          line-height: 1.2;
          margin: 0;
          padding: 0;
          width: 100%;
        }
      }

      select {
        width: 100%;

        & + .button {
          margin-left: 1rem;
        }
      }
    }
  }
}

@media (max-width: 560px) {
  .sticky-header {
    .wrapper {
      h1 {
        font-size: 1.8rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/StickyHeader.vue